import { ReactNode } from 'react';
import AlertIcon from '@/assets/icons/info_circle.svg';
import './styles.css';

interface IProps {
    children?: ReactNode;
    label?: string;
    boldLabel?: boolean;
    biggerLabel?: boolean;
    className?: string;
    testId?: string;
}

export const Info = ({ testId = 'base-info', children, label, boldLabel = true, biggerLabel = false, className = '' }: IProps) => {
    return (
        <div data-testid={testId} className={`border-[0.5px] border-primary bg-mint-200 relative flex w-full flex-col gap-2 overflow-hidden rounded-lg px-5 py-[1.375rem] sm:py-3 ${className}`}>
            <div className="cutted absolute left-0 top-0 h-full w-1.5 bg-primary"></div>
            <div className="flex flex-1 items-center">
                <img className="green h-5 w-5" src={AlertIcon} alt="info icon" />
                {label && (
                    <span data-testid={`${testId}-label`} className={`text-red-500 ${boldLabel ? 'font-bold' : 'font-normal'} ${biggerLabel ? 'text-lg' : 'text-base'}`}>
                        {label}
                    </span>
                )}
                {children && <div data-testid={`${testId}-children`} className="rounded-10 pl-[0.62rem]">{children}</div>}
            </div>
        </div>
    );
};

export default Info;
